export const defaultAutomaticOptions = () => [
	{
		id: 1,
		label: 'Sim, não permitir nova alteração.',
		value: 'activeDisabled'
	},
	{
		id: 2,
		label: 'Sim, permitir nova alteração.',
		value: 'activeEnable'
	},
	{
		id: 3,
		label: 'Desativado',
		value: 'inactive'
	}
]
